import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  FLEET_VEHICLE_DOCUMENT_SEARCH_COLUMNS,
  FLEET_VEHICLE_DOCUMENT_UPLOADS_SEARCH_COLUMNS,

} from "./consts";
import { VehicleDocumentSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import VehicleDocumentRowChild from "./components/VehicleDocumentRowChild";

const VehicleSearchResults: React.FC<VehicleDocumentSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick
  } = props;

  const { t } = useTranslate();
  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_DOCUMENT_SEARCH_COLUMNS(t, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        columnsChild={FLEET_VEHICLE_DOCUMENT_UPLOADS_SEARCH_COLUMNS(t)}
        CustomTableRowChild={(childProps) => (
          <VehicleDocumentRowChild
            {...childProps}
            onFetchSearchResult={() =>
              onPaginationChange?.(searchResults.pagination)
            }
          />
        )}
      />
    </>
  );
};
export default memo(VehicleSearchResults);
